import FeedbackForm from './FeedbackForm';

export default FeedbackForm;
